import { Intensivo } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<Intensivo>('intensivos');
